import React from "react";
import { VendorInvoiceTable } from "./view/VendorInvoiceTable";

interface Props {}

export const InvoiceManager: React.FC<Props> = () => {
  return (
    <>
      <VendorInvoiceTable />
    </>
  );
};
